/**
 * @module currencyDenomination
 * @description A list of currencyDenomination
 */
export const currencyDenomination = [
	{
		name: '',
		description: '',
		amount: 200,
	},
	{
		name: '',
		description: '',
		amount: 100,
	},
	{
		name: '',
		description: '',
		amount: 50,
	},
	{
		name: '',
		description: '',
		amount: 10,
	},
	{
		name: '',
		description: '',
		amount: 5,
	},
	{
		name: '',
		description: '',
		amount: 20,
	},
]
